(function() {
    const form = document.querySelector('.form-event-edit')
    if (!form) return

    check()

    function check() {
        checkPriceSelectedDatesOnly()
    }

    //pokud je zakrtnuto 'Pouze zvolené termíny', tak schovat vsechny inputy s cenou za ostatni dny
    function checkPriceSelectedDatesOnly() {
        var $checkboxDatesOnly = form.querySelector('[name="only_dates"]')

        var pricesContainer = document.getElementById('day-prices')

        var $prices = $(pricesContainer).find('.form-group').toArray()

        if ($checkboxDatesOnly.checked) {
            $prices.forEach(function(formGroup) {
                if (formGroup.dataset.type === "date") {
                    formGroup.style.display = 'none'
                }
            })
        } else {
            $prices.forEach(function(formGroup) {
                formGroup.style.display = ''
            })
        }
    }

    $(document).on('change:dom', function(event) {
        check()
    })

    form.addEventListener('change', function() {
        check()
    })

})();